var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg007Notification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.28994 3.28994C3.10063 3.47771 2.99414 3.7333 2.99414 3.99994C2.99414 4.26658 3.10063 4.52217 3.28994 4.70994L19.2899 20.7099C19.4777 20.8993 19.7333 21.0057 19.9999 21.0057C20.2666 21.0057 20.5222 20.8993 20.7099 20.7099C20.8993 20.5222 21.0057 20.2666 21.0057 19.9999C21.0057 19.7333 20.8993 19.4777 20.7099 19.2899L19.9999 18.5899V10.9999C19.9999 6.58166 16.4182 2.99994 11.9999 2.99994C9.97811 2.99313 8.03082 3.76274 6.55994 5.14994L4.70994 3.28994C4.52217 3.10063 4.26658 2.99414 3.99994 2.99414C3.7333 2.99414 3.47771 3.10063 3.28994 3.28994ZM11.9999 4.99994C15.3136 4.99994 17.9999 7.68623 17.9999 10.9999V16.5899L7.99994 6.55994C9.09521 5.56436 10.5198 5.00876 11.9999 4.99994ZM9.99994 19.9999H3.99994C3.44765 19.9999 2.99994 19.5522 2.99994 18.9999C2.99994 18.4477 3.44765 17.9999 3.99994 17.9999V8.99994C3.99994 8.44765 4.44765 7.99994 4.99994 7.99994C5.55222 7.99994 5.99994 8.44765 5.99994 8.99994V17.9999H14.9999C15.5522 17.9999 15.9999 18.4477 15.9999 18.9999C15.9999 19.5522 15.5522 19.9999 14.9999 19.9999H13.9999C13.9999 21.1045 13.1045 21.9999 11.9999 21.9999C10.8954 21.9999 9.99994 21.1045 9.99994 19.9999Z",
    fill: "#8199A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg007Notification);
export default __webpack_public_path__ + "static/media/007-notification.acb234adebc7b833c6ea770f0095f45e.svg";
export { ForwardRef as ReactComponent };